export default __webpack_public_path__ + "static/media/Fellhammer of the Sanguine Disciple.d364d14a.jpg";